import { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { InfoBox } from "./InfoBox";
import { Button } from "./Button";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const Message = styled.p`
  margin: 0 0 ${spacing.x1}px 0;
  font-size: ${fontSizes.medium}px;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.x1}px;
  align-items: center;
`;

const Secret = styled.code`
  flex: 1 1 320px;
  padding: ${spacing.x1}px ${spacing.x2}px;
  border-radius: ${borderRadius.regular}px;
  background: ${colors.backgroundDark};
  word-break: break-all;
`;

type OneTimeSecretProps = {
  value: string;
  message: string;
  onDone: () => void;
};

export const OneTimeSecret = ({
  value,
  message,
  onDone,
}: OneTimeSecretProps) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const copy = () => {
    void navigator.clipboard.writeText(value).then(() => setCopied(true));
  };

  return (
    <InfoBox variant="warning">
      <Message>{message}</Message>
      <Row>
        <Secret>{value}</Secret>
        <Button type="button" $small onClick={copy}>
          {copied ? t("oneTimeSecret.copied") : t("oneTimeSecret.copy")}
        </Button>
        <Button type="button" $small $variant="outlined" onClick={onDone}>
          {t("oneTimeSecret.done")}
        </Button>
      </Row>
    </InfoBox>
  );
};
